const PerformanceRoutes = [
    {
        path: '/Performance/Admin-Evaluation',
        component: () => import('@/views/Performance/AdminEvaluationView.vue'),
    },
    {
        path: '/Performance/Admin-Probationary-Evaluation',
        component: () => import('@/views/Performance/Admin/Probationary/index.vue'),
    },
    {
        path: '/Performance/Admin-Monthly-Evaluation',
        component: () => import('@/views/Performance/Admin/Monthly/MonthlyEvaluationView.vue'),
    },
    {
        path: '/Performance/Calculate-Performance-Score',
        component: () => import('@/views/Performance/CalculatePerformanceScoreView.vue'),
    },
    {
        path: '/performance/employee-performance',
        component: () => import('@/views/Performance/Admin/Yearly/index.vue'),
    },
    {
        path: '/performance/setup',
        component: () => import('@/views/Performance/Setup/SetupView.vue'),
    },
]

export default PerformanceRoutes;